<input class="fcp-toggle-switch" type="checkbox" [checked]="isActive" [disabled]="disabled" />
<label
    class="fcp-toggle-switch-label {{ size }}"
    (click)="!disabled && statusChange.emit(!isActive)"
    [class.disabled]="disabled"
>
    <span class="fcp-toggle-switch-button {{ size }}" [class.disabled]="disabled"></span>
</label>
